var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Color } from '../const';
import Tooltip from './tooltip';
function SelectTooltip(props) {
    return React.createElement(Tooltip, __assign({}, props, { overlay: React.createElement(Overlay, { itemList: props.itemList }) }));
}
var Overlay = function (props) { return (React.createElement(SelectList, null, props.itemList.map(function (item) { return (React.createElement(SelectItem, { key: item.name, onClick: function () { return item.onClick(); } }, item.name)); }))); };
var SelectList = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 8px 0;\n"], ["\n  margin: 0;\n  padding: 8px 0;\n"])));
var SelectItem = styled.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  padding: 8px 12px;\n\n  &:hover {\n    background-color: ", ";\n    cursor: pointer;\n  }\n"], ["\n  color: ", ";\n  padding: 8px 12px;\n\n  &:hover {\n    background-color: ", ";\n    cursor: pointer;\n  }\n"])), Color.VERY_DARK_GRAY, Color.VERY_PALE_BLUE_2);
export default SelectTooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=select-tooltip.js.map